/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component, Fragment } from 'react'
import { injectIntl, intlShape, FormattedMessage, FormattedNumber } from 'react-intl'
import PropTypes from 'prop-types'
import { API } from 'aws-amplify'
// import { injectStripe, CardElement } from 'react-stripe-elements'
// import { injectStripe, CardElement, useStripe, useElements, Elements, loadStripe } from '@stripe/react-stripe-js'
import { CardElement } from '@stripe/react-stripe-js'
import { CSSTransition } from 'react-css-transition'
import PassTypesSelector from '../components/PassTypesSelector'
import AgeCategorySelector from '../components/AgeCategorySelector'
import CartStandalonePurchase from '../components/CartStandalonePurchase'
import Modal from '../components/Modal'
import BookingPricing from '../components/BookingPricing'
import Button from '../components/Button'
import Spinner from '../components/Spinner'
import CheckmarkIcon from '../icons/checkmarkIcon'
import Textbox from '../components/Textbox'
import TransitionStyles from '../lib/transitionStyles'
import Products from '../lib/products'
import Utils from '../lib/utils'
import GiftcardsOrderCompleted from '../components/giftcards/GiftcardsOrderCompleted'
import { totalOrderSum, totalOrderDiscount, stripeOrderCreateWithPayment } from '../lib/standalonePurchase'
import { putStripeOrder } from '../lib/booking'

class GiftcardsPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      orderCompleted: false,
      submitting: false,
      formOpen: true,
      email: '',
      ageCategory: 'adult',
      comboPaxType: 'combo2pax',
      passType: null,
      items: [],
      atPayment: false,
      showValidationErrors: false,
      submitted: false,
      validationErrors: null
    }
    this.keyCount = 0
    this.getKey         = this.getKey.bind(this)
    this.onChange       = this.onChange.bind(this)
    this.onChangeByName = this.onChangeByName.bind(this)
    this.updateOrder    = this.updateOrder.bind(this)
    this.openPriceModal = this.openPriceModal.bind(this)
    this.openForm       = this.openForm.bind(this)
    this.gotoPayment    = this.gotoPayment.bind(this)
    this.backToCart     = this.backToCart.bind(this)
    // this.totalOrderSum  = this.totalOrderSum.bind(this)
    // this.totalOrderDiscount = this.totalOrderDiscount.bind(this)
    // this.insuranceMandatoryPrice = this.insuranceMandatoryPrice.bind(this)
    this.createOrder    = this.createOrder.bind(this)
  }

  // componentDidMount() {
  //   this.fetchSkus()
  // }

  // async fetchSkus() {
  //   const skus = await bookingLib.fetchSkus()
  //   this.setState((prevState) => ({ ...prevState, skus: skus.data }))
  // }

  onChange(e) {

    if (e.target.name === 'discountCode' && e.target.value.length > 7) {
      this.fetchCoupon(e.target.value)
    }

    this.setState({
      [e.target.name]: e.target.value
    })
  } 

  onChangeByName(name, value) {
    this.setState({
      [name]: value
    })
  }  
  
  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  async fetchCoupon(discountCode) {
    try {
      const couponInfo = await API.post('cphill', '/stripe/proxy', {
        body: {
          endpoint: 'coupons.retrieve',
          parameters: {
            id: discountCode
          }
        }
      })
      this.setState(prevState => ({ ...prevState, couponInfo }))
    } catch (error) {
      // console.debug('No such coupon')
      this.setState(prevState => ({ ...prevState, couponInfo: null }))
    }
  }

  openForm() {
    this.setState({formOpen: true})
  }

  removeItem(index) {
    const { items } = this.state
    items.splice(index, 1)
    this.setState({
      formOpen: items.length === 0,
      items
    })
  }

  updateOrder() {
    const { items, passType } = this.state
    items.push({passType})
    this.setState({
      formOpen: false,
      items
    })
  }

  gotoPayment() {
    this.setState({ atPayment: true })
  }

  backToCart() {
    this.setState({ atPayment: false })
  }

  // async sendStripeOrder(items, email, paymentIntent, couponInfo) {
  //   const { intl, skus } = this.props
  //   const { discountCode } = this.state

  //   const stripeOrder = await stripeOrderCreateWithPayment(items, email, paymentIntent, couponInfo, intl, skus, discountCode)

  //   try {
  //     window.ga('send', 'pageview', '/giftcards/completed')
  //   } catch (error) { /* Do nothing */ }
    
  //   this.setState({ stripeOrder, orderCompleted: true, submitting: false, items: [] })
  // }

  notValid(validationErrors) {
    console.debug({ validationErrors })
    this.setState({ validationErrors, showValidationErrors: true, submitting: false })
  }

  async createOrder() {
    this.setState(prevState => ({...prevState, submitting: true, submitted: true }))
    
    // const { stripe, skus } = this.props
    const { intl, skus, stripe, elements } = this.props
    const { email, items, couponInfo, discountCode } = this.state

    if (!(email && Utils.validateEmail(email))) {
      this.notValid('E-mail problem')
      return
    }

    try {
      const stripeOrder = await stripeOrderCreateWithPayment(items, email, couponInfo, intl, skus, discountCode)
      
      try {
        const paymentIntent = await API.post('cphill', '/stripe/proxy', {
          body: {
            endpoint: 'paymentIntents.create',
            parameters: {
              amount: totalOrderSum(items, skus, discountCode) * 100,
              currency: 'DKK',
              payment_method_types: ['card'],
              metadata: {
                order_type: 'giftcards',
                order_id: stripeOrder.id
              }
            }
          }
        })

        // Pay order
        const cardElement = elements.getElement(CardElement)
        const paymentConfirmation = await stripe.confirmCardPayment(paymentIntent.client_secret, {
          payment_method: {
            card: cardElement,
            billing_details: {
              email
            }
          },
          setup_future_usage: 'on_session'
        })
        if (paymentConfirmation.error) {
          const { error } = paymentConfirmation || {}
          this.notValid(error.message)
          await putStripeOrder(stripeOrder.id, { status: 'canceled' })
        } else {
          await putStripeOrder(stripeOrder.id, {
            metadata: {
              payment_intent: paymentIntent.id
            }
          })

          try {
            window.ga('send', 'pageview', '/giftcards/completed')
          } catch (error) { /* Do nothing */ }

          this.setState({ stripeOrder, orderCompleted: true, submitting: false, items: [] })
        }
      } catch (e) {
        this.notValid(e)
        await putStripeOrder(stripeOrder.id, { status: 'canceled' })
      }
      
    } catch(e) {
      this.notValid(e)
    }    
  }

  openPriceModal() {
    const { skus } = this.props
    const closeModal = () => this.setState(prevState => ({ ...prevState, currentModal: null }))

    this.setState({
      currentModal: (
        <Modal size='lg' closeAction={closeModal}>
          <BookingPricing skus={skus} />
        </Modal>
      )
    })
  }

  // orderCompleted() {
  //   const { email, stripeOrder } = this.state
    
  //   return (
  //     <div className="container mx-auto md:my-10">
  //       <div className="w-5/6 lg:w-3/4 xl:w-2/3 mx-auto">
  //         <CSSTransition {...TransitionStyles} transitionAppear active>
  //           <h5 className="text-harbor-80 uppercase text-sky tracking-wide-2xl">
  //             <FormattedMessage id="giftcards.category" defaultMessage="Giftcards" />
  //           </h5>
  //           <h1 className="text-4xl border-b pb-8">
  //             <FormattedMessage id="giftcards.completed.header" defaultMessage="Thank you for your purchase" />
  //           </h1>
  //           <p className="mt-6">
  //             Gavekort vil blive sendt til nedenstående e-mailadresse.
  //           </p>
  //           <div className="flex justify-center">
  //             <div className="p-6 my-6 bg-grass-60 text-harbor font-bold text-lg">
  //               { email }
  //             </div>
  //           </div>
  //           <p>
  //             Det er vigtigt at du sikrer dig at din e-mail er angivet korrekt.
  //           </p>
  //           <p className="text-sm text-grey-darker">
  //             Hvis din e-mail ikke er korrekt, eller din mail ikke kommer frem, skal du kontakte os på <a href="mailto:info@copenhill.dk" className="text-grey-darker underline font-bold">info@copenhill.dk</a>, og sørg for at angive dit ordrenr.:
  //             &nbsp;
  //             <strong>
  //               {stripeOrder.id}
  //             </strong>
  //           </p>
  //         </CSSTransition>        
  //       </div>
  //     </div>
  //   )
  // }

  paymentForm() {
    const { props } = this
    const { email, showValidationErrors, validationErrors, submitting, submitted, items, discountCode, couponInfo } = this.state

    return (
      <div className="container mx-auto md:my-10">
        <div className="w-5/6 lg:w-3/4 xl:w-2/3 mx-auto">
          <CSSTransition {...TransitionStyles} transitionAppear active>
            <h5 className="text-harbor-80 uppercase text-sky tracking-wide-2xl">
              <FormattedMessage id="giftcards.category" defaultMessage="Giftcards" />
            </h5>
            <h1 className="text-4xl border-b pb-8">
              <FormattedMessage id="giftcards.payment.header" defaultMessage="Payment" />
            </h1>
            <h4 className="text-sky text-center my-8">
              <FormattedMessage
                id="giftcards.payment.headerCard"
                defaultMessage="Fill out your personal details"
              />
            </h4>
            
            <label htmlFor="email">
              <div className="uppercase text-sky font-bold text-sm pl-4">
                <FormattedMessage
                  id="giftcards.payment.labelEmail"
                  defaultMessage="E-mail"
                />
              </div>
              <Textbox
                id='email'
                htmlId='email'
                htmlName='email'
                onChange={this.onChange}
                value={email}
                // className={`${showValidationErrors && !email && 'border-red'} w-full md:w-1/2`}
                className="w-full md:w-1/2"
                valid={submitted ? email && Utils.validateEmail(email) : true}
              />
              <p className="text-sm text-grey pl-4">
                <FormattedMessage
                  id="giftcards.payment.emailHelp"
                  defaultMessage="Giftcards are sent to this e-mail, and can be forwarded"
                />
              </p>
            </label>

            <div className="block pt-4 md:w-1/2">
              <div className="uppercase text-sky font-bold text-sm pl-4">
                <FormattedMessage
                  id="booking.payment.labelCardNo"
                  defaultMessage="Card details"
                />
              </div>
              <CardElement className={`${showValidationErrors && 'border-red'} border rounded-full bg-white px-4 py-3 text-sm`} />
              {showValidationErrors && (
                <p className="text-red">
                  {validationErrors}
                </p>
              )}
            </div>
            <img
              src="https://www.copenhill.dk/user/themes/copenhill/images/creditcards.png?cache1"
              alt="Creditcards"
              className="h-16 -ml-2 mt-4"
            />
            <div className="flex justify-end mb-4 text-xl font-bold">
              <FormattedNumber
                value={totalOrderSum(items, props.skus, discountCode) - totalOrderDiscount(couponInfo, items, props.skus)}
                minimumFractionDigits={2}
              />
              &nbsp;kr.
            </div>
            <div className="flex justify-end items-center">
              {submitting ? (
                <Spinner type="compact" />
              ) : (
                <>
                  <button type="button" onClick={this.backToCart} className="focus:outline-none text-sky uppercase font-bold mr-4">
                    <FormattedMessage id="giftcards.payment.back" defaultMessage="Back" />
                  </button>
                  <Button onClick={this.createOrder} bgCss="bg-grass">
                    <FormattedMessage id="giftcards.payment.buttonPay" defaultMessage="Pay" />
                  </Button>
                </>
              )}
            </div>
          </CSSTransition>
        </div>
      </div>
    )
  }

  render() {
    const { skus } = this.props
    const { formOpen, ageCategory, passType, items, couponInfo, currentModal, atPayment, orderCompleted, comboPaxType, discountCode } = this.state

    // Strange fix - throws an error in console without this
    // https://github.com/wikiwi/react-css-transition/issues/5
    CSSTransition.childContextTypes = {}

    if (skus.length === 0 ) {
      return (
        <div className="flex justify-center">
          <Spinner />
        </div>
      )
    }

    if (orderCompleted) {
      const { email, stripeOrder } = this.state

      return <GiftcardsOrderCompleted email={email} stripeOrder={stripeOrder} />
      // return this.orderCompleted()
    }

    if (atPayment) {
      return this.paymentForm()
    }

    return (
      <>
        {currentModal}

        <div className={`${currentModal && ('fixed')} container mx-auto md:my-10`}>
          <div className="w-5/6 lg:w-3/4 xl:w-2/3 mx-auto">
            <CSSTransition {...TransitionStyles} transitionAppear active>
              <>
                <h5 className="text-harbor-80 uppercase text-sky tracking-wide-2xl">
                  <FormattedMessage
                    id="giftcards.category"
                    defaultMessage="Giftcards"
                  />
                </h5>
                <h1 className="font-black italic md:text-3xl text-2xl">
                  <FormattedMessage
                    id="giftcards.header"
                    defaultMessage="Do you want to bring joy to a loved one?"
                  />
                </h1>
                <p className="mt-6">
                  <strong className="uppercase">
                    <FormattedMessage
                      id="giftcards.descriptionHeader1"
                      defaultMessage="English"
                    />
                  </strong>
                  <br />
                  <FormattedMessage
                    id="giftcards.description1"
                    defaultMessage="English"
                  />
                </p>
                <p>
                  <strong>
                    <FormattedMessage
                      id="giftcards.descriptionHeader2"
                      defaultMessage="English"
                    />
                  </strong>
                  <br />
                  <FormattedMessage
                    id="giftcards.description2"
                    defaultMessage="English"
                  />
                </p>                
                
                <p className="border-b pb-8">
                  {skus && ( // Modal needs prices to be fetched before adding to props
                    <Fragment>
                      <br />
                      <button
                        onClick={this.openPriceModal}
                        className="inline-block text-lg underline text-grass font-normal"
                        type="button"
                      >
                        <FormattedMessage
                          id="giftcards.pricingLink"
                          defaultMessage="See our ski passes and pricing"
                        />
                      </button>
                    </Fragment>
                  )}                
                </p>

                {items && items.map((item, index) => (
                  <CSSTransition key={this.getKey()} {...TransitionStyles} transitionAppear active>
                    <div className="flex items-center border-b pb-4 mb-4">
                      <div className="bg-grass w-16 h-16 rounded-full flex items-center justify-center mr-4">
                        <CheckmarkIcon sizeCss="h-6 w-6" />
                      </div>
                      <div className="flex-grow">
                        <div className="font-bold">
                          <FormattedMessage id={`passTypes.${item.passType}`} />
                        </div>
                        <div className="text-sm">
                          {Products.find(p => p.id === item.passType).ageCategory && (
                            <FormattedMessage
                              id={`giftcards.${Products.find(p => p.id === item.passType).ageCategory}`}
                              defaultMessage={Products.find(p => p.id === item.passType).ageCategory}
                            />
                          )}
                        </div>
                      </div>
                      <button 
                        onClick={() => this.removeItem(index)}
                        className="focus:outline-none text-sky uppercase flex items-center"
                        type="button"
                      >
                        <div className="text-3xl leading-none">&times;</div>
                        <div>
                          <FormattedMessage id="giftcards.remove" defaultMessage="Remove" />
                        </div> 
                      </button>
                    </div>
                  </CSSTransition>
                ))}

                {formOpen && skus.length > 0 && (
                  <>
                    <h4 className="text-sky text-center my-8">
                      <FormattedMessage
                        id="giftcards.selectTypeHeader"
                        defaultMessage="Select the type of giftcard you wish to purchase"
                      />
                    </h4>
                    <AgeCategorySelector
                      ageCategory={ageCategory}
                      onSelect={this.onChangeByName}
                      bgSelected='bg-grey-lighter'
                      btnCss='p-4'
                    />
                    <div className="bg-grey-lighter p-4">
                      <h5 className="text-sky mt-4 mb-0 uppercase italic font-black">
                        <FormattedMessage
                          id="giftcards.categoryHeaderPasses"
                          defaultMessage="Season & advantage passes"
                        />
                      </h5>
                      <PassTypesSelector
                        ageCategory={ageCategory}
                        passType={passType}
                        skus={skus}
                        onSelect={this.onChangeByName}
                        openPriceModal={this.openPriceModal}
                        omitIds={['passHourlyAdult', 'passHourlyChild']}
                        couponInfo={couponInfo}
                        // discountedItems={this.discountedItems()}
                      />

                      <h5 className="text-sky mt-12 mb-0 uppercase italic font-black">
                        <FormattedMessage
                          id="giftcards.categoryHeaderHourly"
                          defaultMessage="Hourly passes & packages"
                        />
                      </h5>

                      <PassTypesSelector
                        ageCategory={ageCategory}
                        passType={passType}
                        skus={skus}
                        onSelect={this.onChangeByName}
                        openPriceModal={this.openPriceModal}
                        omitIds={['passHourlyAdult', 'passHourlyChild']}
                        type='bulk'
                        couponInfo={couponInfo}
                        // discountedItems={this.discountedItems()}
                      />                
                    </div>

                    <h4 className="text-sky text-center my-8">
                      <FormattedMessage
                        id="giftcards.selectComboHeader"
                        defaultMessage="Combos and packages"
                      />
                    </h4>

                    <button
                      className={`${comboPaxType === 'combo2pax' && 'bg-grey-lighter text-harbor'} p-4 text-grey-dark font-bold`}
                      onClick={() => this.setState(prevState => ({ ...prevState, comboPaxType: 'combo2pax' }))}
                      type="button"
                    >
                      <FormattedMessage
                        id="giftcards.combo.tab1"
                        defaultMessage="2 people"
                      />
                    </button>
                    <button
                      className={`${comboPaxType === 'combo3pax' && 'bg-grey-lighter text-harbor'} p-4 text-grey-dark font-bold`}
                      onClick={() => this.setState(prevState => ({ ...prevState, comboPaxType: 'combo3pax' }))}
                      type="button"
                    >
                      <FormattedMessage
                        id="giftcards.combo.tab2"
                        defaultMessage="3 people"
                      />
                    </button>                    
                    <div className="bg-grey-lighter p-4">
                      <PassTypesSelector
                        passType={passType}
                        skus={skus}
                        onSelect={this.onChangeByName}
                        openPriceModal={this.openPriceModal}
                        type={comboPaxType}
                        couponInfo={couponInfo}
                        // discountedItems={this.discountedItems()}
                      />                             
                    </div>

                    <h4 className="text-sky text-center my-8">
                      <FormattedMessage
                        id="giftcards.selectFixedAmount"
                        defaultMessage="Fixed amounts"
                      />
                    </h4>

                    <PassTypesSelector
                      passType={passType}
                      skus={skus}
                      onSelect={this.onChangeByName}
                      openPriceModal={this.openPriceModal}
                      type='fixedAmount'
                      couponInfo={couponInfo}
                      // discountedItems={this.discountedItems()}
                    />
                    {/* 
                    {
                      type: 'fixedAmount',
                    id: 'fixedAmount100',
                    // skuId: isProd ? 'sku_E5qQ97YrjdDFzI' : 'sku_E4GPJyfVKcEtDF',
                    defaultName: 'Fixed amount',
                    giftcardSkuId: isProd ? 'sku_GGgeooiauCRmdD' : ''
                  }, */}
                                      
              
                    <div className="md:flex justify-end mt-8 text-right">
                      <Button
                        onClick={() => (passType && this.updateOrder())}
                        className={`${passType ? '' : 'opacity-50 cursor-not-allowed'}`}
                      >
                        <FormattedMessage 
                          id='giftcards.buttonAddToCart'
                          defaultMessage='Add to cart'
                        />
                      </Button>
                    </div>

                    {/* <div className="inline-block mt-8">
                      <div className="flex items-center text-sm text-grey-dark">
                        <div className="leading-none mr-4">
                          <div className="font-bold">
                            <FormattedMessage
                              id='giftcards.discountCodeLn1'
                              defaultMessage='Discount code?'
                            />
                          </div>
                          <div>
                            <FormattedMessage
                              id='giftcards.discountCodeLn2'
                              defaultMessage='Enter here'
                            />
                          </div>
                        </div>
                        <div>
                          <Textbox
                            htmlId='discountCode'
                            htmlName='discountCode'
                            onChange={this.onChange}
                            value={discountCode}
                          />
                        </div>
                      </div>
                      {(this.discountedItems().length !== 0 || couponInfo) && (
                        <div className="flex justify-end text-grass font-bold text-xs mr-4">
                          <FormattedMessage
                            id='giftcards.discountAdded'
                            defaultMessage='Discount added'
                          />
                        </div>
                      )}
                    </div> */}
                  </>
                )}

                <div className="flex mt-8 justify-end">
                  {!formOpen && (
                    <Button
                      sizeName='sm'
                      onClick={this.openForm}
                    >
                      <FormattedMessage
                        id='giftcards.buttonAddMore'
                        defaultMessage='+ Add more'
                      />
                    </Button>
                  )}
                </div>

                {items && items.length > 0 && (
                  <CSSTransition {...TransitionStyles} transitionAppear active>
                    <CartStandalonePurchase
                      items={items}
                      skus={skus}
                      // totalOrderSum={this.totalOrderSum}
                      // totalOrderDiscount={this.totalOrderDiscount}
                      // insuranceMandatoryPrice={this.insuranceMandatoryPrice}
                      couponInfo={couponInfo}
                      discountCode={discountCode}
                    />
                  
                    <div className="flex justify-end">
                      <Button onClick={this.gotoPayment} bgCss='bg-grass' className='mt-4'>
                        <FormattedMessage
                          id='giftcards.buttonGotoPayment'
                          defaultMessage='Go to payment'
                        />
                      </Button>
                    </div>
                  </CSSTransition>
                )}
              </>
            </CSSTransition>
          </div>

        </div>
      </>
    )
  }
}

GiftcardsPage.propTypes = {
  intl: intlShape.isRequired,
  skus: PropTypes.arrayOf(PropTypes.object)
}

GiftcardsPage.defaultProps = {
  skus: []
}

// const mapStateToProps = state => ({
//   booking: state.booking
// })

export default injectIntl(GiftcardsPage)